import type { FC } from 'react';
import { AccordionLinkGroup } from '../AccordionLinkGroup';
import { useCustomerServiceLinks } from './useCustomerServiceLinks';

export const AccordionCustomerServiceLinks: FC = () => {
    const { data, isLoading } = useCustomerServiceLinks();
    if (isLoading || !data) return null;
    return <AccordionLinkGroup {...data} />;
};
